import React, { useState, useEffect } from "react";
import axios from "axios";
import config from "../config/config";
import DatePicker from "react-datepicker";
import { MdAdsClick } from "react-icons/md";
import { FaRedo } from "react-icons/fa";
const ActivityListingComponent = ({ user }) => {
  const [activities, setActivities] = useState([]);
  const [displayActivities, setDisplayActivities] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [filters, setFilters] = useState({
    email: "",
    timestamp: null,
    action: "",
  });
  const activitiesPerPage = 4;
  const [currentPage, setCurrentPage] = useState(1);

  const baseURL = config.API_BASE_URL;

  useEffect(() => {
    const fetchActivities = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${baseURL}/v1/activity-logs/${user.email}`
        );
        const sortedActivities = response.data.sort((a, b) => {
          return new Date(b.timestamp) - new Date(a.timestamp);
        });
        setActivities(sortedActivities);
        setDisplayActivities(sortedActivities);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    if (user && user.email) {
      fetchActivities();
    }
  }, [user]);

  useEffect(() => {
    const filtered = activities.filter((activity) => {
      const activityDate = new Date(activity.timestamp).toLocaleDateString();
      const filterDate = filters.timestamp
        ? new Date(filters.timestamp).toLocaleDateString()
        : null;
      return (
        (filters.email === "" || activity.email.includes(filters.email)) &&
        (filterDate === null || activityDate === filterDate) &&
        (filters.action === "" || activity.action.includes(filters.action))
      );
    });
    setDisplayActivities(filtered);
  }, [filters, activities]);

  const totalPages = Math.ceil(activities.length / activitiesPerPage);

  const firstPage = () => {
    setCurrentPage(1);
  };

  const prevPage = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 1));
  };

  const nextPage = () => {
    setCurrentPage((prev) => Math.min(prev + 1, totalPages));
  };

  const lastPage = () => {
    setCurrentPage(totalPages);
  };

  const handleFilterChange = (e) => {
    setFilters({ ...filters, [e.target.name]: e.target.value });
  };

  const resetFilters = () => {
    setFilters({
      email: "",
      timestamp: null,
      action: "",
    });
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  return (
    <div>
      <div className="activity-filter-container">
        <div className="activity-filter-email">
          <label>Filter by worker's email</label>
          <input
            type="text"
            name="email"
            value={filters.email}
            onChange={(e) => setFilters({ ...filters, email: e.target.value })}
            placeholder="Filter by Email"
          />
        </div>
        <div className="activity-filter-timestamp">
          <label>Filter by log activity date range</label>
          <DatePicker
            selected={filters.timestamp}
            onChange={(date) => setFilters({ ...filters, timestamp: date })}
            dateFormat="MM/dd/yyyy h:mm aa"
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            placeholderText="Select a date and time"
          />
        </div>
        <div className="activity-filter-action">
          <label>Filter by activity action</label>
          <input
            type="text"
            name="action"
            value={filters.action}
            onChange={(e) => setFilters({ ...filters, action: e.target.value })}
            placeholder="Filter by Activity Action"
          />
        </div>
        <div className="activity-filter-button">
          <button className="clear-filters-button" onClick={resetFilters}>
            <FaRedo className="invoice-filter-reset" /> Reset
          </button>
        </div>
      </div>
      <div className="activity-log-grid">
        {displayActivities
          .slice(
            (currentPage - 1) * activitiesPerPage,
            (currentPage + 1) * activitiesPerPage
          )
          .map((activity) => (
            <div key={activity.id} className="activity-log-item">
              <div className="activity-log-details">
                <h3>
                  <MdAdsClick /> Activity &nbsp;
                  <span className="user-detail-arrow">➤</span> {activity.action}
                </h3>
                <p>
                  <strong>Email</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span> {activity.email}
                </p>
                <p>
                  <strong>Time</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>&nbsp;
                  {new Date(activity.timestamp).toLocaleString()}
                </p>
                <p>
                  <strong>Outcome</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.outcome}
                </p>
                <p>
                  <strong>IP Address</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.ipAddress}
                </p>
                <p>
                  <strong>Activity ID</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span> {activity.id}
                </p>
              </div>
              <div className="activity-log-details">
                <h3>Worker Details</h3>
                <p>
                  <strong>Mobile Number</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.details["Mobile Number"]}
                </p>
                <p>
                  <strong>Primary Location</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.details["Primary Location"]}
                </p>
                <p>
                  <strong>Locked Account</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.details["Locked Account"] ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Verified Email</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.details["Verified Email"] ? "Yes" : "No"}
                </p>
                <p>
                  <strong>Full Name</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.details["Full Name"]}
                </p>
              </div>
              <div className="log-device-info">
                <h3>Device Info</h3>
                <p>
                  <strong>Device Type</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.deviceInfo.deviceType}
                </p>
                <p>
                  <strong>OS</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.deviceInfo.os}
                </p>
                <p>
                  <strong>Browser</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>
                  {activity.deviceInfo.browser}
                </p>
              </div>
              <div className="log-location-info">
                <h3>Location Details</h3>
                <p>
                  <strong>Country</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.locationInfo.country}
                </p>
                <p>
                  <strong>Region</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.locationInfo.regionName} (
                  {activity.locationInfo.region})
                </p>
                <p>
                  <strong>City</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.locationInfo.city}
                </p>
                <p>
                  <strong>Timezone</strong> &nbsp;
                  <span className="user-detail-arrow">➤</span>{" "}
                  {activity.locationInfo.timezone}
                </p>
              </div>
            </div>
          ))}
      </div>
      <div className="activity-log-pagination">
        <button onClick={firstPage} disabled={currentPage === 1}>
          &laquo;
        </button>
        <button onClick={prevPage} disabled={currentPage === 1}>
          &lt;
        </button>
        <span>
          Page <strong>{currentPage}</strong> of <strong>{totalPages}</strong>
        </span>
        <button onClick={nextPage} disabled={currentPage === totalPages}>
          &gt;
        </button>
        <button onClick={lastPage} disabled={currentPage === totalPages}>
          &raquo;
        </button>
      </div>
    </div>
  );
};

export default ActivityListingComponent;
